import React from 'react';
import { Trophy, Medal } from 'lucide-react';

const LeaderboardWidget = () => {
  const toppers = [
    { name: 'Rahul Sharma', score: 95, rank: 1 },
    { name: 'Priya Patel', score: 93, rank: 2 },
    { name: 'Amit Kumar', score: 91, rank: 3 },
  ];

  return (
    <div className="space-y-3">
      <div className="flex items-center space-x-2 mb-4">
        <Trophy className="w-5 h-5 text-yellow-600" />
        <h4 className="font-semibold">Top Performers</h4>
      </div>

      {toppers.map(student => (
        <div key={student.rank} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
          <div className="flex items-center space-x-3">
            <div className={`w-8 h-8 rounded-full flex items-center justify-center ${
              student.rank === 1 ? 'bg-yellow-100' : student.rank === 2 ? 'bg-gray-200' : 'bg-orange-100'
            }`}>
              <span className="font-bold text-sm">{student.rank}</span>
            </div>
            <div>
              <p className="font-medium">{student.name}</p>
              <p className="text-xs text-gray-600">Score: {student.score}%</p>
            </div>
          </div>
          {student.rank <= 3 && <Medal className="w-5 h-5 text-yellow-600" />}
        </div>
      ))}
    </div>
  );
};

export default LeaderboardWidget;